import { ReactNode, createContext, useContext } from 'react'
import { Definition, Organization } from '../../../types'

export interface DataContextInterface {
  data: Organization[]
  definitions: Definition[]
}

export const DATA_DEFAULT: DataContextInterface = {
  data: [],
  definitions: [],
}

const DataContext = createContext<DataContextInterface>(DATA_DEFAULT)

export function useData() {
  return useContext(DataContext)
}

export function DataContextProvider({
  children,
  data,
  definitions,
}: {
  children: ReactNode
  data: Organization[]
  definitions?: Definition[]
}) {
  return (
    <DataContext.Provider
      value={{
        data,
        definitions: definitions || [],
      }}
    >
      {children}
    </DataContext.Provider>
  )
}
